export const formatterPrice = (row, column, cellValue, index) => {
  return (null != cellValue && '' != cellValue ? parseInt(cellValue).toLocaleString() : cellValue) + ' '
}
